<template>
  <section v-if="resumo">
    <div class="content">
      <Titulo
        title="Resumo"
        description="Confira todos os dados antes de finalizar a troca."
      />
      <DadosVidaResumo
        class="mt-3"
        v-for="(resumo, index) in resumoVidas"
        :key="index"
        :dados="resumo"
      />
      <div class="row mt-5 flex-column-reverse flex-md-row">
        <div class="col-md-4 col-lg-2 mt-3 mt-md-0">
          <Botao
            title="Voltar"
            @click="resumo = false"
            name-class="btn btn-outline-secondary btn-lg btn-block"
          >
            Voltar
          </Botao>
        </div>
        <div class="col-md-5 col-lg-4">
          <Botao
            title="Próximo"
            link="/produto/cdl-saude-plano/pagamentoopcional"
            name-class="btn btn-cta btn-lg btn-block font-weight-bold"
          >
            PRÓXIMO
          </Botao>
        </div>
      </div>
      <div class="py-5"></div>
    </div>
  </section>
  <section v-else>
    <div class="produto-cdlsaude-planos">
      <div class="content">
        <Titulo
          title="Opcionais do Plano de Saúde"
          description="Confira todos os dados antes de enviar para a conferência."
        />
        <div class="mt-4">
          <div class="bg-white rounded p-4">
            <div>
              <div class="label">
                {{
                  vidaSel[0].cpF_DEPENDENTE === "" ? "Titular" : "Dependente"
                }}
              </div>
              <div class="value">{{ vidaSel[0].nome }}</div>
            </div>
            <div
              v-if="vidaSel[0].cpF_DEPENDENTE === ''"
              class="alert alert-warning mt-3 mb-0"
            >
              ATENÇÃO! Os opcionais selecionados serão aplicados nos dependentes
              caso possua.
            </div>
            <div v-else class="alert alert-warning mt-3 mb-0">
              ATENÇÃO! Os opcionais selecionados serão aplicados na conta
              titular.
            </div>
          </div>

          <div class="lista-planos mt-3">
            <div class="card border-0">
              <div class="card-header bg-white cursor-pointer operadora-header">
                <h2 class="mb-0 font-weight-bold">
                  {{ vidaSel[0].operadora }}
                </h2>
              </div>
              <div class="card-body p-0 py-3">
                <div
                  class="row justify-content-between align-items-center px-3 pb-3"
                >
                  <div class="col-md-4 col-lg-4">
                    {{ vidaSel[0].assistencia }}
                  </div>
                  <div class="col-md-3 col-lg-3 mt-2 mt-md-0 text-md-right">
                    <small>Acomodação:</small><br />
                    {{ vidaSel[0].acomodacao }}
                  </div>
                  <div class="col-md-4 col-lg-4 mt-2 mt-md-0 text-md-right">
                    <small>Opcional Atual:</small><br />
                    {{ descOpcionalVida ? descOpcionalVida : "NENHUM" }}
                  </div>
                  <div class="col-md-12 mt-3">
                    <div class="lista-opcoes rounded">
                      <FormulateInput
                        type="radio"
                        v-model="opcionais"
                        :options="listaOpcionais"
                        label="Este plano tem opcionais disponíveis:"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-md-4 col-lg-2 mt-3 mt-md-0">
              <Botao
                title="Voltar"
                :link="`/produto/cdl-saude-plano/alterarPlano/${vidaSel[0].cpF_TITULAR}`"
                name-class="btn btn-outline-secondary btn-lg btn-block"
              >
                Voltar
              </Botao>
            </div>
            <div class="col-md-5 col-lg-4">
              <Botao
                title="Próximo"
                @click="salvaOpcionais"
                name-class="btn btn-cta btn-lg btn-block font-weight-bold"
              >
                PRÓXIMO
              </Botao>
            </div>
          </div>
        </div>
        <div class="py-5"></div>
      </div>
    </div>
  </section>
</template>
<script>
import Titulo from "@/components/TituloPaginas";
import Botao from "@/components/botoes/Botao";
import DadosVidaResumo from "@/components/resumo/DadosVidaResumo";
export default {
  name: "CancelarVida",
  components: {
    Titulo,
    Botao,
    DadosVidaResumo,
  },
  data() {
    return {
      produto: {
        nome: "CDL Saúde",
        id: "CDL Saude",
      },
      breadcrumb: [
        {
          nome: "CDL Saúde",
          id: "CDL Saude",
          link: "/produto/cdl-saude",
        },
        {
          nome: "Troca de Opcionais",
          id: "troca_opcionais",
        },
      ],
      listaVidas: [],
      vidaSel: [
        {
          cpF_TITULAR: null,
        },
      ],
      listaOpcionais: [],
      opcionais: [],
      descOpcionalVida: "",
      resumo: false,
      resumoVidas: [],
      opcionaisAtualizado: [],
    };
  },
  methods: {
    montarDados() {
      this.listaVidas = JSON.parse(sessionStorage.getItem("alterPlano"));

      this.vidaSel = this.listaVidas.filter(
        (el) => el.codvida == this.urlParams.codVida
      );

      var opcionalVida = 0;

      this.vidaSel[0].listaOpcional.forEach((opcionalSel) => {
        if (
          opcionalSel.codopcional != "20" &&
          opcionalSel.codopcional != "001"
        ) {
          opcionalVida = opcionalSel.codopcional;
        }
        this.descOpcionalVida += opcionalSel.opcional + " ";
      });

      // Regra dos opcionais, quem tem direito das escolhas
      const regraOpcionais = {
        0: ["0002", "0004"],
        2: ["0003", "0004"],
        3: ["0002", "0004"],
        4: ["0002", "0005"],
        5: ["0002", "0004"],
      };

      const opcionalPermitido = regraOpcionais[opcionalVida];

      this.$http
        .get(
          "/api/CdlBh/ListarOpcional?assistencia=" +
            this.vidaSel[0].codassistencia
        )
        .then(async (response) => {
          response.data.forEach((v) => {
            if (opcionalPermitido.indexOf(v.codopcional) != -1) {
              this.listaOpcionais.push({
                value: v.codopcional,
                label: `${v.opcional} (+${this.$options.filters.currency(
                  v.valor
                )})`,
              });
            }
          });
        });
    },
    salvaOpcionais() {
      this.loading = true;

      const date = new Date();
      date.setDate(date.getDate() + 8);

      const dataVigencia =
        date.getFullYear() +
        "-" +
        ("0" + (date.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + date.getDate()).slice(-2);

      const dadosOpcionais = {
        codVida: this.vidaSel[0].codvida,
        codOpcionais: [this.opcionais],
        dataVigencia: dataVigencia,
      };

      sessionStorage.setItem("trocaOpcionais", JSON.stringify(dadosOpcionais));

      this.$http
        .post("/api/GestaoSaude/SimularTrocaOpcionais", {
          codVida: this.vidaSel[0].codvida,
          codOpcionais: [this.opcionais],
          dataVigencia: dataVigencia,
        })
        .then((response) => {
          this.opcionaisAtualizado = response.data;
          this.prepararResumo();
          this.resumo = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    prepararResumo() {
      this.resumoVidas = [];
      this.listaVidas.forEach((vida) => {
        var listaOpcional = [];
        var totalOpcional = 0;
        const vidaOpcional = this.opcionaisAtualizado.vidas.filter(
          (el) => el.codVida == vida.codvida
        );

        vida.listaOpcional.forEach((opcionalVida) => {
          if (
            opcionalVida.codopcional === 20 ||
            opcionalVida.codopcional === 1
          ) {
            listaOpcional.push({
              opcional: {
                label: opcionalVida.opcional,
                value: opcionalVida.valoropcional,
                novoOpcional: false,
              },
            });
            totalOpcional += opcionalVida.valoropcional;
          }
        });

        vidaOpcional.forEach((codVida) => {
          codVida.opcionais.forEach((opcional) => {
            listaOpcional.push({
              opcional: {
                label: opcional.opcional,
                value: opcional.valorOpcional,
                proRata: opcional.proRata,
                taxaImplantacao: opcional.taxaImplantacao,
                novoOpcional: true,
              },
            });
            totalOpcional += opcional.valorOpcional;
          });
        });

        const dataResumo = {
          tipoCadastro: vida.cpF_DEPENDENTE ? "Dependente" : "Titular",
          nome: vida.nome,
          plano: {
            codPlano: vida.codplanofx,
            operadora: vida.operadora,
            assistencia: vida.assistencia,
            acomodacao: vida.acomodacao,
            valor: vida.valorplano,
          },
          descOpcionais: listaOpcional,
          totalPlano: vida.valorplano + totalOpcional,
        };
        this.resumoVidas.push(dataResumo);
      });
      const carrinho = {
        totalPagamento: this.opcionaisAtualizado.total,
        resumoVidas: this.resumoVidas,
      };
      sessionStorage.setItem("resumoTrocaOpcionais", JSON.stringify(carrinho));
    },
    fechar() {
      this.termoAceite = false;
    },
  },
  computed: {
    urlParams() {
      return this.$route.params;
    },
  },
  mounted() {
    this.montarDados();
  },
  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
  },
  filters: {
    currency(valor) {
      var formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
      return formatter.format(valor);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_vars.scss";
.produto-cdlsaude-planos /deep/ {
  .troca-info {
    font-size: 18px;
    line-height: 1.2;
    .material-icons {
      font-size: 52px;
    }
    .troca-desc {
      padding-left: 5px;
      color: #6c757d;
      strong {
        color: $secondary;
        font-weight: 700;
      }
    }
  }
  .label {
    font-weight: 300;
    font-size: 14px;
    margin-bottom: 6px;
  }
  .value {
    font-weight: bold;
    font-size: 16px;
    text-transform: uppercase;
    color: #000;
    line-height: 1.4;
  }
  .alert {
    font-weight: 700;
  }
  small {
    font-size: 0.8rem;
  }
  .price-total {
    font-weight: 700;
    font-size: 22px;
  }
  .lista-opcoes {
    background: $dark-100;
    .formulate-input-label {
      margin-bottom: 10px;
      font-weight: 700;
      padding: 0.8rem;
    }
    .formulate-input-group {
      .formulate-input-label {
        margin-bottom: 7px;
        font-weight: 400;
        padding: 0rem;
      }
      .formulate-input-element--checkbox {
        margin-right: 5px;
      }
    }
    .formulate-input.formulate-input-group-item {
      padding: 0.8rem;
      label {
        margin: 0;
      }
      &[data-has-value="true"] {
        background: $dark-200;
      }
    }

    .formulate-input[data-classification="button"] {
      padding: 0.8rem;
    }

    formulate-input-errors {
      // Global error message list wrapper
      position: absolute;
      right: 0;
      bottom: 0;
    }

    .formulate-input-error,
    .formulate-file-upload-error {
      // Error message styles
      padding: 6px 8px;
      background-color: #ff5c5c;
      color: white;
      font-size: 12px;
    }
  }
  @import "@/assets/scss/_vue-formulate.scss";
}
</style>
